module.exports = __webpack_public_path__ + "static/img/index-left-top.3cbb112.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/index-left-top.png
// module id = +G6u
// module chunks = 1